module.exports = __webpack_public_path__ + "static/media/no-image.b4fffaec.svg";